export enum NavTabType {
    Profile,
    TermHelpResource,
    CollegeList,
    Interview,
    ComitteReview,
    Essay,
}

export enum ProfileType {
    Student,
    Academic,
    Activity,
    Honor,
}

export enum EssayWorkshopType {
    LifeGoals,
    IdeaAndDraft,
    History,
}

export enum CollegeListWorkshopType {
    Preferences,
    List,
    Navigation,
    Compare,
}

export enum InterviewWorkshopType {
    LiveInterview,
    InterviewHistory,
}

export enum LiveConversationDisplayType {
    Conversation,
    Review,
}

export enum CommitteeReviewWorkshopType {
    CurrentReview,
    ReviewHistory,
}

export enum HelpResourceTermType {
    Help,
    Resource,
    Terms,
    About,
}

